export * from './app-sidebar-footer.component';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/components/app-sidebar-footer/index.ts